import { useEffect, useState } from 'react';
import api from '../config/api';

/**
 * Traveler-facing DVN Private surface (request CTAs + Private Packages tab).
 * Backed by Admin → Features → privateTravel (+ env kill-switch).
 */
export default function usePrivateTravelAvailable() {
  const [available, setAvailable] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    api.get('/public/private-travel/status')
      .then(({ data }) => {
        if (!cancelled) setAvailable(Boolean(data?.available));
      })
      .catch(() => {
        if (!cancelled) setAvailable(false);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { available, loading };
}
